import { Button, IconButton as MuiIconButton, Menu as MuiMenu, MenuItem as MuiMenuItem } from "@mui/material";
import styled from "styled-components";
import theme from "../../theme/theme";

export const StyledTableCard = styled.div`
    background: white;
    border-radius: 8px;
    overflow: hidden;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const StyledTableCell = styled.td`
    padding: 1rem;
    text-align: center;
    vertical-align: middle;

    &:first-child {
        text-align: left;
    }
`;

export const StyledTableRow = styled.tr`
    row-gap: 8px;
    cursor: pointer;

    &:nth-child(even) {
        background-color: #f5f7fa;
    }

    transition: background-color 200ms ease;

    &:hover {
        background-color: rgba(225, 235, 245, 0.7);
    }

    & > ${StyledTableCell}:first-child {
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
    }

    & > ${StyledTableCell}:last-child {
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
    }

    th {
        background: white !important;
        font-weight: 700;
        font-size: 18px;
        color: rgba(38, 38, 38, 1);
        padding: 1rem;
        border-bottom: 1px solid ${theme.palette.primary.main};
        text-align: center;
    }

    th:first-child {
        text-align: left;
    }

    th:last-child {
        width: 40px;
    }

    ${StyledTableCell}:last-child {
        width: 40px;
        padding: 0.5rem;
    }
`;

export const ActionButton = styled(Button)`
    margin: 4px !important;
    text-transform: none !important;
`;

export const IconButton = styled(MuiIconButton)`
    margin: 0 2px;
`;

export const OptionsButton = styled(MuiIconButton)`
    margin: 0 2px;
    width: 100%;
    opacity: 0.65;
    
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
        opacity: 1;
    }
`;

export const ContextMenu = styled(MuiMenu)`
    .MuiPaper-root {
        border-radius: 8px;
    }
`;

export const ContextMenuItem = styled(MuiMenuItem)`
    font-size: 14px;
    padding: 8px 16px;
    min-width: 180px;
    
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;

export const OwnerInfo = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 0;
    opacity: 0.65;
    pointer-events: none;
    
    svg {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }
`;
